import React, { Component, Fragment } from "react";
import { apiURL, registerAPIURL } from "../utils";
import Footer from "../include/Footer";
import Header from "../include/Header";
import { withStyles } from "@material-ui/core/styles";
import {
  CssBaseline,
  Grid,
  Container,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Snackbar,
  Switch,
  InputAdornment,
  Button,
  Popover,
  IconButton,
  MenuItem,
  Select,
  Typography,
  FormControl,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import SearchIcon from "@material-ui/icons/Search";
import axios from "axios";
import Helmet from "react-helmet";
import Delete from "../delete/Delete";
import Box from "@material-ui/core/Box";
import { TableContainer } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import {
  DatePicker,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import XLSX from "xlsx";
import ExportExcelButton from "../utils/ExportExcelButton";
import Moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import { CloseRounded, CloudUpload } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";

const drawerWidth = 280;

const useStyles = (makeStyles) => ({
  delButton: {
    textTransform: "capitalize",
    border: "1px solid #f26522",
    borderRadius: "0px",
    padding: "2px 5px",
  },
  buttonAdd: {
    textTransform: "capitalize",
  },
  closeButton: {
    padding: 2,
    fontSize: 24,
  },
  selectField: {
    padding: "0rem",
  },
  bulkUploadBtn: {
    textTransform: "capitalize",
    backgroundColor: "#f26522",
    color: "#fff",
    marginRight: "10px",
    "&:hover": {
      backgroundColor: "#d55418",
    },
  },
  statusDelivered: {
    color: "#2e7d32",
    backgroundColor: "#e8f5e9",
    padding: "4px 8px",
    borderRadius: "4px",
    display: "inline-block",
    fontSize: "12px",
    fontWeight: 500,
  },
  statusNotDelivered: {
    color: "#c62828",
    backgroundColor: "#ffebee",
    padding: "4px 8px",
    borderRadius: "4px",
    display: "inline-block",
    fontSize: "12px",
    fontWeight: 500,
  },
  uploadDialogContent: {
    padding: "20px",
  },
  uploadProgress: {
    marginTop: "10px",
  },
  summaryContainer: {
    marginTop: "20px",
    padding: "15px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
  },
  successText: {
    color: "#2e7d32",
  },
  errorText: {
    color: "#c62828",
  },
});

const cities = [
  "Achalpur",
  "Ahmednagar",
  "Akola",
  "Amravati",
  "Ambarnath",
  "Aurangabad",
  "Barshi",
  "Beed",
  "Bhivandi-Nizampur",
  "Bhusawal",
  "Chandrapur",
  "Dhule",
  "Gondia",
  "Hinganghat",
  "Ichalkaranji",
  "Jalgaon",
  "Jalna",
  "Kalyan-Dombivli",
  "Kolhapur",
  "Latur",
  "Malegaon",
  "Mira-Bhayandar",
  "Mumbai City",
  "Mumbai Suburban",
  "Nagpur",
  "Nanded Waghala",
  "Nandurbar",
  "Nashik",
  "Navi Mumbai",
  "Osmanabad",
  "Palghar",
  "Panvel",
  "Parbhani",
  "Pimpri-Chinchwad",
  "PMC, Pune",
  "Ratnagiri",
  "Sangli-Miraj-Kupwad",
  "Satara",
  "Sindhudurg",
  "Solapur",
  "Thane",
  "Ulhasnagar",
  "Udgir",
  "Vasai-Virar City MC",
  "Wardha",
  "Yavatmal",
];

class RegisteredUsers extends Component {
  _isMounted = false;

  static defaultProps = {
    event_type: "past_webinar",
  };

  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: true,
      teacherData: [],
      page: 1,
      per: 50,
      total_pages: null,
      loading: false,
      showSnackbar: false,
      snackBarMessage: "",
      severityColor: "",
      searchValue: "",
      noData: "",
      fromDate: null,
      toDate: null,
      anchorEl: null,
      openPopover: false,
      filteredTeacherData: [],
      currentPage: 1,
      selectedUsers: [],
      selectAll: false,
      uploadDialogOpen: false,
      uploading: false,
      uploadResults: null,
      summaryDialogOpen: false,
      summaryData: null,
    };
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.teacherListData = this.teacherListData.bind(this);
    this.snackBarClose = this.snackBarClose.bind(this);
  }

  handleDrawerOpen(drawerState) {
    this.setState({
      drawerOpen: drawerState,
    });
  }

  snackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ showSnackbar: false });
  };

  showSnackbarMessage = (message, severity) => {
    let safeMessage = "";
    if (typeof message === "string") {
      safeMessage = message;
    } else if (message && typeof message === "object") {
      safeMessage = message.message || message.error || JSON.stringify(message);
    } else {
      safeMessage = String(message || "Operation completed");
    }

    this.setState({
      showSnackbar: true,
      snackBarMessage: safeMessage,
      severityColor: severity || "info",
    });
  };

  componentWillMount() {
    this._isMounted = true;
    this.teacherListData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleBulkUploadClick = () => {
    const { selectedUsers, filteredTeacherData } = this.state;

    let usersToProcess = [];

    if (selectedUsers.length === 0) {
      // No selection
      // Take ALL Not Delivered users

      usersToProcess = filteredTeacherData.filter((user) => {
        return (
          user.flg_certificate_delivered === 0 ||
          user.flg_certificate_delivered === "0" ||
          user.flg_certificate_delivered === false
        );
      });
    } else {
      // Selected users
      // Take ONLY selected + Not Delivered users

      usersToProcess = filteredTeacherData.filter((user) => {
        const isSelected = selectedUsers.indexOf(user.fldi_id) !== -1;

        const isNotDelivered =
          user.flg_certificate_delivered === 0 ||
          user.flg_certificate_delivered === "0" ||
          user.flg_certificate_delivered === false;

        return isSelected && isNotDelivered;
      });
    }

    this.setState({
      uploadDialogOpen: true,
      pendingUploadUsers: usersToProcess,
    });
  };

  handleBulkUploadSubmit = async () => {
    const { pendingUploadUsers } = this.state;
    const event_type =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.event_type
        ? this.props.location.state.event_type
        : this.props.event_type;
    const event_id =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.webinar_id
        ? this.props.location.state.webinar_id
        : "";

    // console.log("========== BULK UPLOAD SUBMIT ==========");
    // console.log("Users to process count:", pendingUploadUsers.length);

    this.setState({ uploading: true });

    try {
      let payload = {
        event_id: parseInt(event_id),
        event_type: event_type,
      };

      // ONLY add contactNumbers if users are selected (Scenario 2 & 3)
      if (pendingUploadUsers && pendingUploadUsers.length > 0) {
        const contactNumbers = pendingUploadUsers
          .map((user) => user.fldv_contact)
          .filter(Boolean);

        payload.contactNumbers = contactNumbers;
        // console.log(
        //   "Sending with contactNumbers:",
        //   contactNumbers.length,
        //   contactNumbers,
        // );
      }

      // console.log("Final Payload:", JSON.stringify(payload, null, 2));

      const response = await axios.post(
        apiURL("achievement/bulkupload"),
        payload,
        { headers: { "Content-type": "application/json" } },
      );

      // console.log("API Response:", response.data);

      const responseData = response.data;

      if (responseData.status === true) {
        this.setState({
          uploading: false,
          uploadDialogOpen: false,
          summaryData: {
            status: true,
            message:
              responseData.message || "Certificates generated successfully",
            total_updated_users: responseData.total_updated_users || 0,
            updated_contact_numbers: responseData.updated_contact_numbers || [],
          },
          summaryDialogOpen: true,
          selectedUsers: [],
          selectAll: false,
        });

        // Refresh after success
        setTimeout(() => {
          this.teacherListData();
        }, 1500);
      } else {
        this.setState({
          uploading: false,
          uploadDialogOpen: false,
          summaryData: {
            status: false,
            message: responseData.message || "Operation failed",
            total_updated_users: 0,
          },
          summaryDialogOpen: true,
        });
      }
    } catch (error) {
      console.error("Bulk upload error:", error);
      this.setState({
        uploading: false,
        uploadDialogOpen: false,
        summaryData: {
          status: false,
          message:
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "Failed to generate certificates",
        },
        summaryDialogOpen: true,
      });
    }
  };

  handleSelectUser = (userId) => {
    let newSelectedUsers;
    if (this.state.selectedUsers.indexOf(userId) !== -1) {
      newSelectedUsers = this.state.selectedUsers.filter(function (id) {
        return id !== userId;
      });
    } else {
      newSelectedUsers = this.state.selectedUsers.concat([userId]);
    }

    this.setState({
      selectedUsers: newSelectedUsers,
      selectAll:
        newSelectedUsers.length === this.state.filteredTeacherData.length,
    });
  };

  handleSelectAll = () => {
    const newSelectAll = !this.state.selectAll;
    let newSelectedUsers;

    if (newSelectAll) {
      newSelectedUsers = this.state.filteredTeacherData.map(function (user) {
        return user.fldi_id;
      });
    } else {
      newSelectedUsers = [];
    }

    this.setState({
      selectAll: newSelectAll,
      selectedUsers: newSelectedUsers,
    });
  };

  handlePopoverOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget, openPopover: true });
  };

  handlePopoverClose = () => {
    this.setState({ anchorEl: null, openPopover: false });
  };

  handleFromDateChange = (date) => {
    this.setState({ fromDate: date }, () => this.filterTeacherData());
  };

  handleToDateChange = (date) => {
    this.setState({ toDate: date }, () => this.filterTeacherData());
  };

  handleCityFilterChange = (event) => {
    const selectedCity = event.target.value;
    this.setState({ searchValue: selectedCity }, () => {
      this.teacherListData();
    });
  };

  handleChangePerPage = (event) => {
    this.setState({ per: event.target.value, page: 1 }, () => {
      this.teacherListData();
    });
  };

  clearFilters = () => {
    this.setState(
      {
        fromDate: null,
        toDate: null,
      },
      () => {
        this.filterTeacherData();
      },
    );
  };

  filterTeacherData = () => {
    const { fromDate, toDate, teacherData, searchValue } = this.state;
    let filteredData = [...teacherData];

    if (searchValue !== "") {
      filteredData = filteredData.filter((teacher) =>
        teacher.city_name === null || teacher.city_name === ""
          ? teacher.fldi_city.toLowerCase().includes(searchValue.toLowerCase())
          : teacher.city_name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    }

    if (fromDate && toDate) {
      filteredData = filteredData.filter((teacher) => {
        const teacherDate = Moment(teacher.flddt_added_date);
        return teacherDate.isBetween(fromDate, toDate, null, "[]");
      });
    }

    this.setState({ filteredTeacherData: filteredData });
  };

  handlePageChange = (page) => {
    this.setState({ page: page, currentPage: page }, () => {
      this.teacherListData();
    });
  };

  teacherListData = () => {
    const { per, page } = this.state;
    const { event_type = "past_webinar" } = this.props;
    // Replace optional chaining with traditional check
    const webinar_id =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.webinar_id
        ? this.props.location.state.webinar_id
        : "";

    const body = { webinar_id, event_type };

    // console.log("Fetching registered users...");

    axios
      .post(
        apiURL(`webinar/get_registered_user?per_page=${per}&page=${page}`),
        body,
        { headers: { "Content-type": "application/json" } },
      )
      .then((response) => {
        if (!this._isMounted) return;

        const resultData = response.data;

        if (resultData.status === true || resultData.status === 1) {
          const usersWithStatus = resultData.result.map((user) => {
            // Stronger type checking
            const rawFlag = user.flg_certificate_delivered;
            const isDelivered =
              rawFlag === 1 || rawFlag === "1" || rawFlag === true;

            // console.log(
            //   `User ${user.fldv_first_name || user.fldv_name}: raw flg=${rawFlag} (${typeof rawFlag}) → ${isDelivered ? "Delivered" : "Not Delivered"}`,
            // );

            return {
              ...user,
              certificateStatus: isDelivered ? "Delivered" : "Not Delivered",
            };
          });

          this.setState(
            {
              teacherData: usersWithStatus,
              total_pages: resultData.total_pages,
            },
            () => {
              this.filterTeacherData();
              this.setState({ loading: false });
            },
          );
        }
      })
      .catch((error) => {
        console.error("Failed to load users:", error);
        this.showSnackbarMessage("Failed to load registered users", "error");
      });
  };

  changeStatus = (id, status) => {
    const headers = { "Content-type": "application/json" };
    const body = {
      id: id,
      status: status.toString(),
    };
    const self = this;
    axios
      .post(apiURL("teacher/change_status"), body, { headers: headers })
      .then(function (response) {
        const resultData = response.data;
        if (resultData.status === true || resultData.status === 1) {
          const updateTeacherData = self.state.teacherData.map(
            function (teacher) {
              if (teacher.fldi_id === id) {
                const _teacher = Object.assign({}, teacher);
                _teacher.flg_status = status === "0" ? "1" : "0";
                return _teacher;
              }
              return teacher;
            },
          );
          self.setState({ teacherData: updateTeacherData });
          self.showSnackbarMessage("Status updated successfully", "success");
        }
      })
      .catch(function (error) {
        // console.log(error);
        self.showSnackbarMessage("Failed to update status", "error");
      });
  };

  successDelete = (e, id) => {
    e.preventDefault();
    const headers = { "Content-type": "application/json" };
    const webinar_id = this.props.location.state
      ? this.props.location.state.webinar_id
      : undefined;
    const body = {
      webinar_id: webinar_id || "",
      user_id: id,
    };
    const self = this;
    axios
      .post(registerAPIURL(`join_webinar_user/delete`), body, {
        headers: headers,
      })
      .then(function (response) {
        if (self._isMounted) {
          const resultData = response.data;
          if (resultData.status === true || resultData.status === 1) {
            self.showSnackbarMessage("Data deleted successfully", "success");
            self.componentWillMount();
          }
        }
      })
      .catch(function (error) {
        // console.log(error);
        self.showSnackbarMessage("Failed to delete user", "error");
      });
  };

  fetchAllUsers = async function () {
    const { per } = this.state;
    const { event_type = "past_webinar" } = this.props;
    // Replace optional chaining with traditional check
    const webinar_id =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.webinar_id
        ? this.props.location.state.webinar_id
        : "";

    let allData = [];
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      try {
        const res = await axios.post(
          apiURL(`webinar/get_registered_user?per_page=${per}&page=${page}`),
          { webinar_id: webinar_id, event_type: event_type },
        );
        const data = res.data;
        if (
          data &&
          (data.status === true || data.status === 1) &&
          Array.isArray(data.result) &&
          data.result.length > 0
        ) {
          const usersWithStatus = data.result.map(function (user) {
            const rawFlag = user.flg_certificate_delivered;
            const isDelivered =
              rawFlag === 1 || rawFlag === "1" || rawFlag === true;
            const status = isDelivered ? "Delivered" : "Not Delivered";
            return Object.assign({}, user, { certificateStatus: status });
          });
          allData = allData.concat(usersWithStatus);
          page++;
        } else {
          hasMore = false;
        }
      } catch (error) {
        // console.log(error);
        hasMore = false;
      }
    }
    return allData;
  };

  exportFile = async function () {
    try {
      const allTeachers = await this.fetchAllUsers();
      let teachers = [
        [
          "Name",
          "Email",
          "Phone Number",
          "City",
          "Subject",
          "School / College",
          "Board & Medium",
          "Grades Taught/Managed",
          "Registered Date",
          "Source",
          "Status",
          "Certificate Status",
          "Delete",
        ],
      ];

      for (let i = 0; i < allTeachers.length; i++) {
        const teacher = allTeachers[i];
        teachers.push([
          teacher.fldv_first_name || teacher.fldv_name,
          teacher.fldv_email,
          teacher.fldv_contact,
          teacher.fldi_city,
          teacher.fldv_subjects_taught || teacher.fldv_subject,
          teacher.fldv_school_college,
          teacher.fldv_board_medium,
          teacher.fldv_grades_taught,
          Moment(teacher.flddt_updated_date).format("D MMMM, YYYY"),
          teacher.fldv_source,
          Number(teacher.flg_status) === 1 ? "Active" : "Deactive",
          teacher.certificateStatus || "Not Delivered",
          Number(teacher.flg_is_deleted) === 1 ? "Not Deleted" : "Deleted",
        ]);
      }

      const wb = XLSX.utils.book_new();
      const wsAll = XLSX.utils.aoa_to_sheet(teachers);
      XLSX.utils.book_append_sheet(wb, wsAll, "All Teachers");
      XLSX.writeFile(wb, "export-registered-teachers.xlsx");
      this.showSnackbarMessage("Export completed successfully", "success");
    } catch (error) {
      console.error("Export error:", error);
      this.showSnackbarMessage("Failed to export data", "error");
    }
  };

  renderPaginationButtons = () => {
    const { total_pages, currentPage } = this.state;

    if (!total_pages || total_pages <= 1) return null;

    const buttons = [];
    const maxButtons = 3;
    let startPage = 1;
    let endPage = total_pages;

    if (total_pages > maxButtons) {
      if (currentPage <= 3) {
        endPage = maxButtons;
      } else if (currentPage >= total_pages - 2) {
        startPage = total_pages - maxButtons + 1;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 1;
      }
    }

    buttons.push(
      <Button
        key="prev"
        size="small"
        disabled={currentPage === 1}
        onClick={() => this.handlePageChange(currentPage - 1)}
      >
        Prev
      </Button>,
    );

    if (startPage > 1) {
      buttons.push(
        <Button
          key={1}
          size="small"
          variant={currentPage === 1 ? "contained" : "outlined"}
          onClick={() => this.handlePageChange(1)}
        >
          1
        </Button>,
      );
    }

    if (startPage > 1) {
      buttons.push(
        <span
          key="prevEllipsis"
          style={{
            width: "36px",
            display: "inline-block",
            textAlign: "center",
          }}
        >
          ...
        </span>,
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <Button
          key={i}
          size="small"
          variant={currentPage === i ? "contained" : "outlined"}
          onClick={() => this.handlePageChange(i)}
        >
          {i}
        </Button>,
      );
    }

    if (endPage < total_pages) {
      buttons.push(
        <span
          key="nextEllipsis"
          style={{
            width: "36px",
            display: "inline-block",
            textAlign: "center",
          }}
        >
          ...
        </span>,
      );
    }

    if (endPage < total_pages) {
      buttons.push(
        <Button
          key={total_pages}
          size="small"
          variant={currentPage === total_pages ? "contained" : "outlined"}
          onClick={() => this.handlePageChange(total_pages)}
        >
          {total_pages}
        </Button>,
      );
    }

    buttons.push(
      <Button
        key="next"
        size="small"
        disabled={currentPage === total_pages}
        onClick={() => this.handlePageChange(currentPage + 1)}
      >
        Next
      </Button>,
    );

    return buttons;
  };

  render() {
    const { classes } = this.props;
    const {
      page,
      per,
      selectedUsers,
      selectAll,
      uploadDialogOpen,
      pendingUploadUsers,
      uploading,
      summaryDialogOpen,
      summaryData,
    } = this.state;

    const startIndex = (page - 1) * per + 1;
    const loadingCSS = { height: "30px", margin: "10px" };
    const loadingTextCSS = { display: this.state.loading ? "block" : "none" };

    return (
      <React.Fragment>
        <Helmet>
          <title>Registered User</title>
        </Helmet>
        <Header forwardDrawerOpen={this.handleDrawerOpen.bind(this)} />
        <CssBaseline />
        <div
          style={{
            paddingTop: "5rem",
            paddingLeft: this.state.drawerOpen ? drawerWidth + 15 : 72 + 15,
            transition: "padding 0.5s ease",
          }}
        >
          <main>
            <Container maxWidth="lg">
              <Box bgcolor="background.paper" mt={2} boxShadow={3}>
                <Alert
                  action={
                    <div>
                      <Button
                        variant="contained"
                        className={classes.bulkUploadBtn}
                        startIcon={<CloudUpload />}
                        onClick={this.handleBulkUploadClick.bind(this)}
                      >
                        Bulk Upload Certificates
                      </Button>
                      <ExportExcelButton
                        clickProp={(e) => this.exportFile(e)}
                      />
                    </div>
                  }
                  variant="outlined"
                  severity="default"
                  boxShadow={3}
                >
                  <h2>Registered User</h2>
                </Alert>
              </Box>

              <Grid container spacing={3} align="center">
                <Grid item xs={12}>
                  <Box
                    bgcolor="background.paper"
                    boxShadow={3}
                    px={2}
                    py={2}
                    mt={1}
                  >
                    <TableContainer
                      mt={1}
                      component={Paper}
                      className="customTable"
                    >
                      <Table
                        size="small"
                        stickyHeader
                        aria-label="sticky table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={selectAll}
                                onChange={this.handleSelectAll.bind(this)}
                                color="primary"
                              />
                            </TableCell>
                            <TableCell>Id</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Email Address</TableCell>
                            <TableCell>Phone Number</TableCell>
                            <TableCell>City</TableCell>
                            <TableCell>Subject</TableCell>
                            <TableCell>School / College</TableCell>
                            <TableCell>Board & Medium</TableCell>
                            <TableCell>Grades Taught/Managed</TableCell>
                            <TableCell>Registered Date</TableCell>
                            <TableCell>Source</TableCell>
                            <TableCell>Certificate Status</TableCell>
                            <TableCell>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.filteredTeacherData.map(
                            function (arrList, index) {
                              const isSelected =
                                selectedUsers.indexOf(arrList.fldi_id) !== -1;

                              const isDelivered =
                                arrList.flg_certificate_delivered === 1 ||
                                arrList.flg_certificate_delivered === "1" ||
                                arrList.flg_certificate_delivered === true;
                              const displayStatus = isDelivered
                                ? "Delivered"
                                : "Not Delivered";

                              return (
                                <TableRow key={index} selected={isSelected}>
                                  <TableCell padding="checkbox">
                                    <Checkbox
                                      checked={
                                        arrList.flg_certificate_delivered ===
                                          1 ||
                                        arrList.flg_certificate_delivered ===
                                          "1" ||
                                        arrList.flg_certificate_delivered ===
                                          true
                                          ? true
                                          : isSelected
                                      }
                                      disabled={
                                        arrList.flg_certificate_delivered ===
                                          1 ||
                                        arrList.flg_certificate_delivered ===
                                          "1" ||
                                        arrList.flg_certificate_delivered ===
                                          true
                                      }
                                      onChange={function () {
                                        this.handleSelectUser(arrList.fldi_id);
                                      }.bind(this)}
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell>{startIndex + index}</TableCell>
                                  <TableCell>
                                    {arrList.fldv_first_name === ""
                                      ? arrList.fldv_name
                                      : arrList.fldv_first_name}
                                  </TableCell>
                                  <TableCell>{arrList.fldv_email}</TableCell>
                                  <TableCell>{arrList.fldv_contact}</TableCell>
                                  <TableCell>{arrList.fldi_city}</TableCell>
                                  <TableCell>
                                    {arrList.fldv_subjects_taught === ""
                                      ? arrList.fldv_subject
                                      : arrList.fldv_subjects_taught}
                                  </TableCell>
                                  <TableCell>
                                    {arrList.fldv_school_college}
                                  </TableCell>
                                  <TableCell>
                                    {arrList.fldv_board_medium}
                                  </TableCell>
                                  <TableCell>
                                    {arrList.fldv_grades_taught}
                                  </TableCell>
                                  <TableCell>
                                    {Moment(arrList.registered_date).format(
                                      "D MMMM, YYYY",
                                    )}
                                  </TableCell>
                                  <TableCell>{arrList.fldv_source}</TableCell>
                                  <TableCell>
                                    <span
                                      className={
                                        displayStatus === "Delivered"
                                          ? classes.statusDelivered
                                          : classes.statusNotDelivered
                                      }
                                    >
                                      {displayStatus}
                                    </span>
                                  </TableCell>
                                  <TableCell>
                                    <Button
                                      variant="outlined"
                                      color="default"
                                      className={classes.delButton}
                                      startIcon={
                                        <DeleteIcon
                                          style={{ color: "#f26522" }}
                                        />
                                      }
                                      onClick={function (e) {
                                        if (
                                          window.confirm(
                                            "Are you sure? You want to delete this item",
                                          )
                                        ) {
                                          this.successDelete(
                                            e,
                                            arrList.fldi_id,
                                          );
                                        }
                                      }.bind(this)}
                                    >
                                      Delete
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              );
                            }.bind(this),
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <div style={loadingCSS}>
                    <span style={loadingTextCSS}>Loading...</span>
                    <span>{this.state.scrolling ? this.state.noData : ""}</span>
                  </div>
                </Grid>
              </Grid>

              <Grid
                container
                justify="flex-end"
                style={{ marginTop: "0.8rem", marginBottom: "1.5rem" }}
              >
                <Grid item>{this.renderPaginationButtons()}</Grid>
              </Grid>
              <Footer />
            </Container>
          </main>
        </div>

        <Dialog
          open={uploadDialogOpen}
          onClose={function () {
            if (!uploading) this.setState({ uploadDialogOpen: false });
          }.bind(this)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: "16px",
              overflow: "hidden",
            },
          }}
        >
          <DialogTitle
            style={{
              fontWeight: 600,
              padding: "20px 24px 12px",
              position: "relative",
            }}
          >
            Generate Certificates
            {!uploading && (
              <IconButton
                style={{
                  position: "absolute",
                  right: 12,
                  top: 12,
                  background: "#f5f5f5",
                }}
                onClick={function () {
                  this.setState({ uploadDialogOpen: false });
                }.bind(this)}
              >
                <CloseRounded />
              </IconButton>
            )}
          </DialogTitle>

          <DialogContent className={classes.uploadDialogContent}>
            <Typography
              variant="body1"
              gutterBottom
              style={{
                color: "#555",
                marginBottom: "10px",
              }}
            >
              You are about to generate certificates for:
            </Typography>

            <Typography
              variant="h6"
              color="primary"
              style={{ fontWeight: 700, marginBottom: "16px" }}
            >
              {pendingUploadUsers && pendingUploadUsers.length > 0
                ? `${pendingUploadUsers.length} user(s) will be processed`
                : "All Not Delivered users will be processed by the system"}
            </Typography>

            {pendingUploadUsers && pendingUploadUsers.length > 0 && (
              <div
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  padding: "12px",
                  background: "#fafafa",
                  maxHeight: "260px",
                  overflowY: "auto",
                }}
              >
                {pendingUploadUsers.map(function (user, index) {
                  return (
                    <div
                      key={index}
                      style={{
                        padding: "10px 12px",
                        marginBottom: "8px",
                        background: "#fff",
                        borderRadius: "8px",
                        border: "1px solid #f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Typography
                        variant="body2"
                        style={{
                          fontWeight: 500,
                          color: "#333",
                          wordBreak: "break-word",
                        }}
                      >
                        •{" "}
                        {user.fldv_first_name === ""
                          ? user.fldv_name
                          : user.fldv_first_name}
                      </Typography>

                      <Typography
                        variant="caption"
                        style={{
                          color: "#777",
                        }}
                      >
                        ({user.fldv_contact})
                      </Typography>
                    </div>
                  );
                })}
              </div>
            )}

            {pendingUploadUsers && pendingUploadUsers.length === 0 && (
              <div
                style={{
                  padding: "20px",
                  textAlign: "center",
                  background: "#f0f7ff",
                  borderRadius: "8px",
                  marginTop: "10px",
                }}
              >
                <Typography variant="body2" style={{ color: "#0066cc" }}>
                  No specific users selected. The system will process all users
                  whose certificates are Not Delivered
                </Typography>
              </div>
            )}

            {uploading && (
              <div className={classes.uploadProgress}>
                <LinearProgress
                  style={{
                    borderRadius: "10px",
                    height: "8px",
                  }}
                />
                <Typography
                  variant="body2"
                  style={{
                    marginTop: "12px",
                    textAlign: "center",
                    color: "#666",
                  }}
                >
                  Generating certificates. Please wait...
                </Typography>
              </div>
            )}
          </DialogContent>

          <DialogActions
            style={{
              padding: "16px 24px 20px",
              borderTop: "1px solid #f0f0f0",
            }}
          >
            <Button
              onClick={function () {
                this.setState({ uploadDialogOpen: false });
              }.bind(this)}
              disabled={uploading}
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleBulkUploadSubmit.bind(this)}
              variant="contained"
              className={classes.bulkUploadBtn}
              disabled={uploading}
            >
              {uploading ? "Generating..." : "Confirm & Generate"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={summaryDialogOpen}
          onClose={() => this.setState({ summaryDialogOpen: false })}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            {summaryData && summaryData.status ? "Success" : "Failed"}
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" gutterBottom>
              {summaryData ? summaryData.message : ""}
            </Typography>
            {summaryData && summaryData.status === true && (
              <Typography variant="body2" style={{ marginTop: "10px" }}>
                Total Users Updated: {summaryData.total_updated_users}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ summaryDialogOpen: false })}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={this.state.showSnackbar === true}
          autoHideDuration={this.state.snackBarTimer || 4000}
          onClose={(e) => this.snackBarClose(e)}
        >
          <Alert
            onClose={(e) => this.snackBarClose(e)}
            severity={this.state.severityColor}
            elevation={6}
            variant="filled"
          >
            {this.state.snackBarMessage}
          </Alert>
        </Snackbar>
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(RegisteredUsers);
